import axios from 'axios';

export default axios.create({
  baseURL: 'https://chingu-travel-planning-app.herokuapp.com/'
});
